import React from 'react';
import { SuccessButton } from 'components/button';
import Footer from 'components/footer';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { InputMintDiv } from 'views/common-styled-components';
import { CommonStyledComponentProps } from '__utils/type';
import { COLOR } from 'constants/colors';
import { useForm } from 'react-hook-form';
import { PaymentFlowHelper } from '../paymentFlow.helper';
import { getQueryParamsFromString } from '__utils/common-utils';


const Step2Container = styled.div<CommonStyledComponentProps>`
    label{
        font-weight: 500;
        font-size: 14px;
    }
  
`;

const Step = styled.div<CommonStyledComponentProps>`
    flex: 1;
`;

const PayStep = styled.div<CommonStyledComponentProps>`

    position: relative;
    h5 {
        font-size: 16px;
        color: ${COLOR.GREEN};
        line-height: normal;
        font-weight: 500;
        padding: 10px 0px;
    }
`;

const NeftForm: React.FC = () => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { register, handleSubmit, formState, } = useForm({ mode: 'onChange' });
    const { makeBSEpayment } = PaymentFlowHelper();
    const { loopBackUrl } = getQueryParamsFromString(window.location.search);
    
    const onProceed = (data: any) => {
      
        makeBSEpayment({ paymentMode: 2, neftReferenceNumber: data.utrNo }, onSuccessfulPayment);
    }

    const onSuccessfulPayment = (response:any)=>{
        window.location.replace(`${window.location.origin}/v1/${loopBackUrl}`);
    }
    return (
        <>
            <Step2Container isMobile={ isMobile }>

                <Step isMobile={ isMobile }>
                    <PayStep isMobile={ isMobile }>
                        <h5>Step 2</h5>
                        <p>Complete money transfer and obtain UTR number. </p>
                        <form id="utrForm" onSubmit={ handleSubmit(onProceed) } style={ { marginTop: '8px' } }>
                            <InputMintDiv>
                                <label htmlFor='utrNo'>Enter UTR Number</label>
                                <input
                                    name='utrNo'
                                    id='utrNo'
                                    type="text"
                                    placeholder='Input Text'
                                    ref={register({
                                        required: "Please enter UTR number",
                                    }) }
                                />
                            </InputMintDiv>
                        </form>
                    </PayStep>
                </Step>

            </Step2Container>
            { isMobile ? <Footer>
                <SuccessButton type="submit" form="utrForm" disabled={ !formState.isValid }>Confirm Payment</SuccessButton>
            </Footer> :
                <SuccessButton type="submit" form="utrForm" disabled={ !formState.isValid }>Confirm Payment</SuccessButton>
            }

        </>
    )
}

export default NeftForm;
